<template>
  <div
    class="content"
    @touchstart="doClick"
    @touchmove="doNothing"
    @touchend="doNothing"
  >
    <div
      v-show="makeExplosion"
      @click="explode($event.clientX, $event.clientY)"
    >
      <canvas id="canvas" />
      <transition name="fade">
        <div v-if="makeExplosion">
          <div class="central-message player-1">
            {{ player1Message }}
          </div>
          <hr
            style="border:1px solid white; position:absolute; top: 50%; width: calc(100% - 10px); margin: 0px"
          />
          <div class="central-message player-2">
            {{ player2Message }}
          </div>

          <button class="button central-button player-1" @click="nextRound()">
            {{
              matchWinner
                ? $t("simon.nextMatchButton")
                : $t("simon.nextRoundButton")
            }}
          </button>
          <button class="button central-button player-2" @click="nextRound()">
            {{
              matchWinner
                ? $t("simon.nextMatchButton")
                : $t("simon.nextRoundButton")
            }}
          </button>
        </div>
      </transition>
    </div>

    <div v-show="!makeExplosion">
      <h2
        v-if="!counting && clickDisabled && !showGuideCircles"
        class="title"
        style="color: white;"
      >
        {{ $t("mainTitle") }}
      </h2>
      <div
        v-for="index in 5"
        :key="index + '-2'"
        :id="index + '-2'"
        class="circle"
        :style="{
          width: circleSize + 'px',
          height: circleSize + 'px',
          top: index % 2 ? '20%' : `calc(20% + ${circleSize * 0.8}px)`,
          left: `calc(50% - ${circleSize / 2}px + ${(index - 3) *
            circleSize *
            0.9}px)`,
          'background-color': colors[index - 1],
        }"
        @click="!clickDisabled && circleClicked(index + '-2', $event)"
      />

      <transition name="fade">
        <div v-if="showGuideCircles">
          <div
            v-for="index in 5"
            :key="index + '-guide'"
            :id="index + '-guide'"
            class="circle"
            :style="{
              width: circleSize + 'px',
              height: circleSize + 'px',
              top:
                index % 2
                  ? `calc(47% - ${circleSize / 2}px)`
                  : `calc(47% - ${circleSize / 2}px + ${circleSize * 0.8}px)`,
              left: `calc(50% - ${circleSize / 2}px + ${(index - 3) *
                circleSize *
                0.9}px)`,
              'background-color': colors[index - 1],
            }"
          />
        </div>
      </transition>

      <button
        v-if="!counting && clickDisabled && !showGuideCircles"
        class="button central-button"
        @click="showSequence(sequenceNumber)"
      >
        {{
          players[1].roundWins || players[2].roundWins
            ? $t("simon.startRoundButton")
            : $t("simon.startMatchButton")
        }}
      </button>

      <transition name="fade">
        <div v-if="counting || !clickDisabled">
          <div class="central-message player-1">
            {{ centralMessage }}
          </div>
          <hr
            style="border:1px solid white; position:absolute; top: 50%; width: calc(100% - 10px); margin: 0px"
          />
          <div class="central-message player-2">
            {{ centralMessage }}
          </div>
        </div>
      </transition>

      <div
        v-for="index in 5"
        :key="index + '-1'"
        :id="index + '-1'"
        class="circle"
        :style="{
          width: circleSize + 'px',
          height: circleSize + 'px',
          top:
            index % 2
              ? `calc(80% - ${circleSize}px  - ${circleSize * 0.8}px)`
              : `calc(80% - ${circleSize}px)`,
          left: `calc(50% - ${circleSize / 2}px + ${(index - 3) *
            circleSize *
            0.9}px)`,
          'background-color': colors[index - 1],
        }"
        @click="!clickDisabled && circleClicked(index + '-1', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";

export default {
  mixins: [mixin],

  data() {
    return {
      colors: ["#FF0000", "#FFFF00", "#00FF00", "#0000FF", "#800080"],
      players: {
        1: { correctButtons: 0, roundWins: 0 },
        2: { correctButtons: 0, roundWins: 0 },
      },
      expectedButtons: [],
      makeExplosion: false,
      clickDisabled: true,
      showGuideCircles: false,
      counterStartValue: 3,
      counter: 0,
      counting: false,
      roundWinner: 0,
      matchWinner: 0,
    };
  },

  computed: {
    circleSize() {
      return window.innerHeight / 10;
    },
    sequenceNumber() {
      const roundsPlayed =
        this.players[1].roundWins + this.players[2].roundWins;
      if (roundsPlayed === 0) return 3;
      if (roundsPlayed === 1) return 5;
      if (roundsPlayed === 2) return 7;
    },
    centralMessage() {
      if (this.counting) return this.counter;
      else return this.$t("simon.centralMessage.go");
    },
    player1Message() {
      if (this.matchWinner) {
        if (this.matchWinner === "1") {
          return this.$t("simon.matchWinner");
          // return "You win! Prepare a gorgeous shot of happiness for your opponent. =)";
        } else {
          return this.$t("simon.matchLoser");
        }
      } else {
        if (this.roundWinner === "1") {
          return this.$t("simon.roundWinner");
        } else {
          return this.$t("simon.roundLoser");
        }
      }
      return "";
    },
    player2Message() {
      if (this.matchWinner) {
        if (this.matchWinner === "2") {
          return this.$t("simon.matchWinner");
          // return "You win! Prepare a beautiful shot of happiness for your opponent. =)";
        } else {
          return this.$t("simon.matchLoser");
        }
      } else {
        if (this.roundWinner === "2") {
          return this.$t("simon.roundWinner");
        } else {
          return this.$t("simon.roundLoser");
        }
      }
      return "";
    },
  },

  mounted() {
    this.explode = this.setExplosion();
  },

  methods: {
    resetVariables() {
      this.makeExplosion = false;
      if (this.matchWinner) {
        this.players[1].roundWins = 0;
        this.players[2].roundWins = 0;
      }
      this.matchWinner = 0;
      this.roundWinner = 0;
      this.players[1].correctButtons = 0;
      this.players[2].correctButtons = 0;
      this.clickDisabled = true;
    },
    nextRound() {
      this.resetVariables();
    },
    decreaseCounter() {
      this.counter--;
      if (this.counter === 0) {
        clearInterval(this.intervalCounter);
        this.counting = false;
      }
    },
    startCount() {
      this.counter = this.counterStartValue;
      this.counting = true;
      this.intervalCounter = setInterval(this.decreaseCounter, 1000);
    },
    async showSequence(quantity) {
      // Exibe circulos guia
      this.showGuideCircles = true;

      // Aguarda um tempo
      await new Promise((r) => setTimeout(r, 1000));

      // Gerar sequencia (1 segundo de delay por item)
      this.expectedButtons = [];
      for (var i = 0; i < quantity; i++) {
        const buttonIndex = Math.floor(Math.random() * 5) + 1;
        this.paintCircle(buttonIndex + "-guide");
        this.expectedButtons.push(buttonIndex);
        await new Promise((r) => setTimeout(r, 1000));
      }

      this.showGuideCircles = false;
      this.startCount();
      await new Promise((r) => setTimeout(r, this.counterStartValue * 1000));
      this.clickDisabled = false;
    },
    setExplosion() {
      // Little Canvas things
      var canvas = document.querySelector("#canvas");
      var ctx = canvas.getContext("2d");

      // Set Canvas to be window size
      canvas.width = window.innerWidth;
      canvas.height = document.getElementsByClassName(
        "content"
      )[0].clientHeight;
      canvas.style.margin = "-29px -5px";
      // Configuration, Play with these
      var config = {
        particleNumber: 100,
        maxParticleSize: 15,
        maxSpeed: 10,
        colorVariation: 0,
      };

      // Colors
      var colorPalette = {
        bg: { r: 0, g: 0, b: 0 },
        matter: [
          { r: 255, g: 0, b: 0 },
          { r: 0, g: 255, b: 0 },
          { r: 0, g: 0, b: 255 },
          { r: 253, g: 255, b: 0 },
          { r: 128, g: 0, b: 128 },
        ],
      };

      // Some Variables hanging out
      var particles = [],
        centerX = canvas.width / 2,
        centerY = canvas.height / 2,
        drawBg,
        // Draws the background for the canvas, because space
        drawBg = function(ctx, color) {
          ctx.fillStyle =
            "rgb(" + color.r + "," + color.g + "," + color.b + ")";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        };

      // Particle Constructor
      var Particle = function(x, y) {
        // X Coordinate
        this.x = x || Math.round(Math.random() * canvas.width);
        // Y Coordinate
        this.y = y || Math.round(Math.random() * canvas.height);
        // Radius of the space dust
        this.r = Math.ceil(Math.random() * config.maxParticleSize);
        // Color of the rock, given some randomness
        this.c = colorVariation(
          colorPalette.matter[
            Math.floor(Math.random() * colorPalette.matter.length)
          ],
          true
        );
        // Speed of which the rock travels
        this.s = Math.pow(Math.ceil(Math.random() * config.maxSpeed), 0.7);
        // Direction the Rock flies
        this.d = Math.round(Math.random() * 360);
      };

      // Provides some nice color variation
      // Accepts an rgba object
      // returns a modified rgba object or a rgba string if true is passed in for argument 2
      var colorVariation = function(color, returnString) {
        var r, g, b, a, variation;
        r = Math.round(
          Math.random() * config.colorVariation -
            config.colorVariation / 2 +
            color.r
        );
        g = Math.round(
          Math.random() * config.colorVariation -
            config.colorVariation / 2 +
            color.g
        );
        b = Math.round(
          Math.random() * config.colorVariation -
            config.colorVariation / 2 +
            color.b
        );
        a = Math.random() + 0.5;
        if (returnString) {
          return "rgba(" + r + "," + g + "," + b + "," + a + ")";
        } else {
          return { r, g, b, a };
        }
      };

      // Used to find the rocks next point in space, accounting for speed and direction
      var updateParticleModel = function(p) {
        var a = 180 - (p.d + 90); // find the 3rd angle
        p.d > 0 && p.d < 180
          ? (p.x += (p.s * Math.sin(p.d)) / Math.sin(p.s))
          : (p.x -= (p.s * Math.sin(p.d)) / Math.sin(p.s));
        p.d > 90 && p.d < 270
          ? (p.y += (p.s * Math.sin(a)) / Math.sin(p.s))
          : (p.y -= (p.s * Math.sin(a)) / Math.sin(p.s));
        return p;
      };

      // Just the function that physically draws the particles
      // Physically? sure why not, physically.
      var drawParticle = function(x, y, r, c) {
        ctx.beginPath();
        ctx.fillStyle = c;
        ctx.arc(x, y, r, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.closePath();
      };

      // Remove particles that aren't on the canvas
      var cleanUpArray = function() {
        particles = particles.filter((p) => {
          return p.x > -100 && p.y > -100;
        });
      };

      var initParticles = function(numParticles, x, y) {
        for (let i = 0; i < numParticles; i++) {
          particles.push(new Particle(x, y));
        }
        particles.forEach((p) => {
          drawParticle(p.x, p.y, p.r, p.c);
        });
      };

      // That thing
      window.requestAnimFrame = (function() {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();

      // Our Frame function
      var frame = function() {
        // Draw background first
        drawBg(ctx, colorPalette.bg);
        // Update Particle models to new position
        particles.map((p) => {
          return updateParticleModel(p);
        });
        // Draw em'
        particles.forEach((p) => {
          drawParticle(p.x, p.y, p.r, p.c);
        });
        // Play the same song? Ok!
        window.requestAnimFrame(frame);
      };

      // First Frame
      frame();

      return function(x, y) {
        cleanUpArray();
        initParticles(config.particleNumber, x, y - 50);
      };
    },
    expectedButton(player) {
      return this.expectedButtons[this.players[player].correctButtons];
    },
    paintCircle(buttonID) {
      const circleElement = document.getElementById(buttonID);
      const circleID = circleElement.id;
      const circleIndex = circleID.split("-")[0];

      const baseBackgroundColor = circleElement.style.backgroundColor;
      circleElement.style.backgroundColor = "#ffffff";
      setTimeout(() => {
        circleElement.style.backgroundColor = this.colors[circleIndex - 1];
      }, 300);
    },
    doNothing(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    doClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if(event.touches.length > 0) {
        Array.prototype.forEach.call(event.touches, (touch) => {
          const x = touch.clientX;
          const y = touch.clientY;
          const event = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: x,
            clientY: y,
          });
          const element = document.elementFromPoint(x, y);
          element.dispatchEvent(event);
        });
      }
    },
    circleClicked(buttonID, clickEvent) {
      const buttonIndex = buttonID.split("-")[0];
      const player = buttonID.split("-")[1];
      const correctButtonClicked = buttonIndex == this.expectedButton(player);
      if (!correctButtonClicked) {
        console.warn("Perdeu!");
      } else {
        this.players[player].correctButtons++;
        const lastButtonPressed =
          this.players[player].correctButtons === this.expectedButtons.length;
        if (lastButtonPressed) {
          this.players[player].roundWins++;
          if (this.players[player].roundWins > 1) this.matchWinner = player;
          this.roundWinner = player;
          this.clickDisabled = true;
          this.makeExplosion = true;
          this.explode(clickEvent.clientX, clickEvent.clientY);
        } else {
          this.paintCircle(buttonID);
        }
      }
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px soild black;
}

.title {
  text-align: center;
}
.description {
  text-align: left;
}
.page {
  margin: 100px auto 0;
  width: 500px;
  display: flex;
  justify-content: space-between;
}

.circle {
  border-radius: 50%;
  position: absolute;
}

.texto-centralizado {
  position: absolute;
  top: 40%;
  left: 50%;
  font-size: 24px;
  color: white;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);
}

.imagem-centro-circulo {
  position: absolute;
  top: 35px;
  left: 35px;
  width: 50px;
}

/* Essas classes estão causando Fade na tela toda do Simon */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.central-message {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 24px;
  color: white;
}

.central {
  transform: translateX(-50%) translateY(-50%);
}

.central-button {
  margin: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 24px;
  color: white;
  transform: translate(-50%, -50%);
}

.central-button.player-1 {
  width: 60%;
  top: 88%;
}

.central-button.player-2 {
  width: 60%;
  top: 12%;
  transform: rotate(180deg) translate(50%, 50%);
}

.central-message.player-1 {
  width: 80%;
  top: 50%;
  text-align: center;
  font-size: 20px;
  transform: translate(-50%, 20%);
}

.central-message.player-2 {
  width: 80%;
  top: 50%;
  text-align: center;
  font-size: 20px;
  /* transform: rotate(180deg) translate(50%, 50%); */
  transform: rotate(180deg) translate(50%, 120%);
}

.button {
  border-radius: 20px;
  color: black;
  border: 0px;
  font-size: 24px;
  width: 140px;
}
</style>
